import BarChartIcon from '@mui/icons-material/BarChart'
import { Button } from '@mui/material'
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid'
import React from 'react'

import { MetaDataTableRow } from '../../../../types/metaDataTableRows'
import LinkComponent from '../../../Navigation/link'
import { StatusChip } from '../../statusChip'

export const metaDataColumns: GridColDef[] = [
    {
        field: 'id',
    },
    {
        field: 'expId',
        headerName: 'Exp ID',
    },
    {
        field: 'name',
        headerName: 'Name',
        minWidth: 200,
        flex: 1,
        renderCell: (params: GridRenderCellParams<MetaDataTableRow, string>) => {
            const expId = params.row.expId
            return (
                <LinkComponent
                    pathName={'/experimentDetails/[expId]'}
                    query={{ experimentId: expId }}
                    value={params.value}
                    asValue={`/experimentDetails/${expId}`}
                />
            )
        },
    },
    {
        field: 'domain',
        headerName: 'Website',
        flex: 1,
    },
    {
        field: 'slots',
        headerName: 'Slots',
        // flex: 1,
        renderCell: (params: GridRenderCellParams<MetaDataTableRow, string>) => {
            const slots = params.row.slots
            return <>{slots} available</>
        },
    },
    {
        field: 'startDate',
        headerName: 'Start date and time',
        type: 'dateTime',
        flex: 1,
    },
    {
        field: 'endDate',
        headerName: 'End date and time',
        type: 'dateTime',
        flex: 1,
    },
    {
        field: 'status',
        headerName: 'Status',
        type: 'singleSelect',
        minWidth: 130,
        filterable: true,
        flex: 1,
        valueOptions: ['Archived', 'Live', 'Scheduled', 'Paused', 'Concluded'],
        renderCell: (params: GridRenderCellParams<MetaDataTableRow, string>) => {
            return <StatusChip status={params.row.status} />
        },
        getApplyQuickFilterFn: (value: string) => {
            return (params: GridRenderCellParams<MetaDataTableRow, string>) => {
                return params.value === value
            }
        },
    },
    {
        field: 'type',
        headerName: 'Type',
        type: 'singleSelect',
        flex: 1,
        valueOptions: ['Campaign', 'Standard'],
        getApplyQuickFilterFn: (value: string) => {
            return (params: GridRenderCellParams<MetaDataTableRow, string>) => {
                return params.value === value
            }
        },
    },
    {
        field: 'dashboard',
        headerName: 'Dashboard',
        minWidth: 170,
        flex: 1,
        filterable: false,
        sortable: false,
        renderCell: (params: GridRenderCellParams<MetaDataTableRow, string>) => {
            const expName = params.row.name
            return (
                <LinkComponent
                    pathName={'/dashboard/[expName]'}
                    query={{ experimentName: expName }}
                    asValue={`/dashboard/${expName}`}
                >
                    <Button
                        data-test="dashbaordButton"
                        variant={'outlined'}
                        startIcon={<BarChartIcon />}
                        sx={{ textOverflow: 'none' }}
                    >
                        View Report
                    </Button>
                </LinkComponent>
            )
        },
    },
]
